// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.storyteller-form {
  min-height: 100vh;
  background: rgba(249, 250, 251, 0.5);
}
.storyteller-form .form-container {
  margin: 0 auto;
  padding: 1.5rem;
}
.storyteller-form .form-header {
  margin-bottom: 2rem;
}
.storyteller-form .form-header .header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.storyteller-form .form-header .header-content .header-text h1 {
  font-size: 1.875rem;
  font-weight: 700;
  letter-spacing: -0.025em;
  color: #111827;
  margin: 0;
}
.storyteller-form .form-header .header-content .header-text p {
  color: #6b7280;
  margin: 0.5rem 0 0 0;
}
.storyteller-form .form-header .header-content .cancel-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.15s ease-in-out;
  cursor: pointer;
  border: 1px solid transparent;
}
.storyteller-form .form-header .header-content .cancel-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.storyteller-form .form-header .header-content .cancel-button {
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #6b7280;
}
.storyteller-form .form-header .header-content .cancel-button:hover {
  color: #111827;
}
.storyteller-form .form-header .header-content .cancel-button .icon {
  height: 1rem;
  width: 1rem;
}
.storyteller-form .alert {
  margin-bottom: 1.5rem;
  border-radius: 0.5rem;
  padding: 1rem;
}
.storyteller-form .alert.success {
  border: 1px solid rgba(16, 185, 129, 0.2);
  background: rgba(16, 185, 129, 0.05);
}
.storyteller-form .alert.success .alert-content p {
  font-size: 0.875rem;
  font-weight: 500;
  color: rgb(7.8805970149, 91.1194029851, 63.5373134328);
  margin: 0;
}
.storyteller-form .alert.error {
  border: 1px solid rgba(239, 68, 68, 0.2);
  background: rgba(239, 68, 68, 0.05);
}
.storyteller-form .alert.error .alert-content p {
  font-size: 0.875rem;
  font-weight: 500;
  color: rgb(188.842364532, 16.157635468, 16.157635468);
  margin: 0;
}
.storyteller-form .form-sections {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
.storyteller-form .form-section {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  padding: 1.5rem;
}
.storyteller-form .form-section .section-header {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  cursor: pointer;
}
.storyteller-form .form-section .section-header .section-title {
  text-align: left;
}
.storyteller-form .form-section .section-header .section-title h2 {
  font-size: 1.125rem;
  font-weight: 600;
  color: #111827;
  margin: 0;
}
.storyteller-form .form-section .section-header .section-title p {
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0.25rem 0 0 0;
}
.storyteller-form .form-section .section-header .chevron-icon {
  height: 1.25rem;
  width: 1.25rem;
  color: #6b7280;
  transition: transform 0.2s ease-in-out;
}
.storyteller-form .form-section .section-content .form-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
}
@media (min-width: 768px) {
  .storyteller-form .form-section .section-content .form-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 1024px) {
  .storyteller-form .form-section .section-content .form-grid.three-cols {
    grid-template-columns: repeat(3, 1fr);
  }
}
.storyteller-form .form-section .section-content .form-grid.full-width {
  grid-template-columns: 1fr;
}
@media (min-width: 768px) {
  .storyteller-form .form-section .section-content .form-grid.full-width {
    grid-column: span 2;
  }
}
.storyteller-form .form-section .section-content .form-field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.storyteller-form .form-section .section-content .form-field label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #111827;
}
.storyteller-form .form-section .section-content .form-field label .required {
  color: #ef4444;
}
.storyteller-form .form-section .section-content .form-field input,
.storyteller-form .form-section .section-content .form-field textarea,
.storyteller-form .form-section .section-content .form-field select {
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  color: #111827;
  background: white;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.storyteller-form .form-section .section-content .form-field input::placeholder,
.storyteller-form .form-section .section-content .form-field textarea::placeholder,
.storyteller-form .form-section .section-content .form-field select::placeholder {
  color: #6b7280;
}
.storyteller-form .form-section .section-content .form-field input:focus,
.storyteller-form .form-section .section-content .form-field textarea:focus,
.storyteller-form .form-section .section-content .form-field select:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 1px #2563eb;
}
.storyteller-form .form-section .section-content .form-field textarea {
  resize: vertical;
  min-height: 4rem;
}
.storyteller-form .form-section .section-content .checkbox-field {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.storyteller-form .form-section .section-content .checkbox-field input[type=checkbox] {
  height: 1rem;
  width: 1rem;
  border-radius: 0.375rem;
  border: 1px solid #e5e7eb;
  color: #2563eb;
}
.storyteller-form .form-section .section-content .checkbox-field input[type=checkbox]:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);
}
.storyteller-form .form-section .section-content .checkbox-field label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #111827;
  margin: 0;
}
.storyteller-form .array-section .array-item {
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  padding: 1rem;
  margin-bottom: 1rem;
}
.storyteller-form .array-section .array-item .item-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.75rem;
}
.storyteller-form .array-section .array-item .item-header h4 {
  font-size: 0.875rem;
  font-weight: 500;
  color: #111827;
  margin: 0;
}
.storyteller-form .array-section .array-item .item-header .delete-button {
  color: #ef4444;
}
.storyteller-form .array-section .array-item .item-header .delete-button:hover {
  color: rgb(234.9802955665, 21.0197044335, 21.0197044335);
}
.storyteller-form .array-section .array-item .item-header .delete-button .icon {
  height: 1rem;
  width: 1rem;
}
.storyteller-form .array-section .array-item .item-content {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
}
@media (min-width: 768px) {
  .storyteller-form .array-section .array-item .item-content {
    grid-template-columns: repeat(2, 1fr);
  }
}
.storyteller-form .array-section .add-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.15s ease-in-out;
  cursor: pointer;
  border: 1px solid transparent;
}
.storyteller-form .array-section .add-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.storyteller-form .array-section .add-button {
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  color: #2563eb;
  background: transparent;
}
.storyteller-form .array-section .add-button:hover {
  color: #1d4ed8;
}
.storyteller-form .array-section .add-button .icon {
  height: 1rem;
  width: 1rem;
}
.storyteller-form .array-field .array-item {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}
.storyteller-form .array-field .array-item input {
  flex: 1 1;
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  color: #111827;
  background: white;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.storyteller-form .array-field .array-item input::placeholder {
  color: #6b7280;
}
.storyteller-form .array-field .array-item input:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 1px #2563eb;
}
.storyteller-form .array-field .array-item .delete-button {
  padding: 0.5rem 0.75rem;
  color: #ef4444;
}
.storyteller-form .array-field .array-item .delete-button:hover {
  color: rgb(234.9802955665, 21.0197044335, 21.0197044335);
}
.storyteller-form .array-field .array-item .delete-button .icon {
  height: 1rem;
  width: 1rem;
}
.storyteller-form .array-field .add-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.15s ease-in-out;
  cursor: pointer;
  border: 1px solid transparent;
}
.storyteller-form .array-field .add-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.storyteller-form .array-field .add-button {
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  color: #2563eb;
  background: transparent;
}
.storyteller-form .array-field .add-button:hover {
  color: #1d4ed8;
}
.storyteller-form .array-field .add-button .icon {
  height: 1rem;
  width: 1rem;
}
.storyteller-form .schedule-section .day-item {
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  padding: 1rem;
  margin-bottom: 1.5rem;
}
.storyteller-form .schedule-section .day-item .day-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}
.storyteller-form .schedule-section .day-item .day-header h4 {
  font-size: 0.875rem;
  font-weight: 500;
  color: #111827;
  margin: 0;
}
.storyteller-form .schedule-section .day-item .day-header .delete-button {
  color: #ef4444;
}
.storyteller-form .schedule-section .day-item .day-header .delete-button:hover {
  color: rgb(234.9802955665, 21.0197044335, 21.0197044335);
}
.storyteller-form .schedule-section .day-item .day-header .delete-button .icon {
  height: 1rem;
  width: 1rem;
}
.storyteller-form .schedule-section .day-item .day-content {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  margin-bottom: 1rem;
}
@media (min-width: 768px) {
  .storyteller-form .schedule-section .day-item .day-content {
    grid-template-columns: repeat(2, 1fr);
  }
}
.storyteller-form .schedule-section .day-item .day-content .full-width {
  grid-column: 1/-1;
}
.storyteller-form .schedule-section .day-item .activities-section,
.storyteller-form .schedule-section .day-item .meals-section {
  margin-bottom: 1rem;
}
.storyteller-form .schedule-section .day-item .activities-section label,
.storyteller-form .schedule-section .day-item .meals-section label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #111827;
  margin-bottom: 0.5rem;
  display: block;
}
.storyteller-form .schedule-section .day-item .activities-section .activity-item,
.storyteller-form .schedule-section .day-item .activities-section .meal-item,
.storyteller-form .schedule-section .day-item .meals-section .activity-item,
.storyteller-form .schedule-section .day-item .meals-section .meal-item {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}
.storyteller-form .schedule-section .day-item .activities-section .activity-item input,
.storyteller-form .schedule-section .day-item .activities-section .meal-item input,
.storyteller-form .schedule-section .day-item .meals-section .activity-item input,
.storyteller-form .schedule-section .day-item .meals-section .meal-item input {
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  color: #111827;
  background: white;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.storyteller-form .schedule-section .day-item .activities-section .activity-item input::placeholder,
.storyteller-form .schedule-section .day-item .activities-section .meal-item input::placeholder,
.storyteller-form .schedule-section .day-item .meals-section .activity-item input::placeholder,
.storyteller-form .schedule-section .day-item .meals-section .meal-item input::placeholder {
  color: #6b7280;
}
.storyteller-form .schedule-section .day-item .activities-section .activity-item input:focus,
.storyteller-form .schedule-section .day-item .activities-section .meal-item input:focus,
.storyteller-form .schedule-section .day-item .meals-section .activity-item input:focus,
.storyteller-form .schedule-section .day-item .meals-section .meal-item input:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 1px #2563eb;
}
.storyteller-form .schedule-section .day-item .activities-section .activity-item input.time-input,
.storyteller-form .schedule-section .day-item .activities-section .meal-item input.time-input,
.storyteller-form .schedule-section .day-item .meals-section .activity-item input.time-input,
.storyteller-form .schedule-section .day-item .meals-section .meal-item input.time-input {
  width: 8rem;
}
.storyteller-form .schedule-section .day-item .activities-section .activity-item input.flex-input,
.storyteller-form .schedule-section .day-item .activities-section .meal-item input.flex-input,
.storyteller-form .schedule-section .day-item .meals-section .activity-item input.flex-input,
.storyteller-form .schedule-section .day-item .meals-section .meal-item input.flex-input {
  flex: 1 1;
}
.storyteller-form .schedule-section .day-item .activities-section .activity-item .delete-button,
.storyteller-form .schedule-section .day-item .activities-section .meal-item .delete-button,
.storyteller-form .schedule-section .day-item .meals-section .activity-item .delete-button,
.storyteller-form .schedule-section .day-item .meals-section .meal-item .delete-button {
  padding: 0.5rem 0.75rem;
  color: #ef4444;
}
.storyteller-form .schedule-section .day-item .activities-section .activity-item .delete-button:hover,
.storyteller-form .schedule-section .day-item .activities-section .meal-item .delete-button:hover,
.storyteller-form .schedule-section .day-item .meals-section .activity-item .delete-button:hover,
.storyteller-form .schedule-section .day-item .meals-section .meal-item .delete-button:hover {
  color: rgb(234.9802955665, 21.0197044335, 21.0197044335);
}
.storyteller-form .schedule-section .day-item .activities-section .activity-item .delete-button .icon,
.storyteller-form .schedule-section .day-item .activities-section .meal-item .delete-button .icon,
.storyteller-form .schedule-section .day-item .meals-section .activity-item .delete-button .icon,
.storyteller-form .schedule-section .day-item .meals-section .meal-item .delete-button .icon {
  height: 1rem;
  width: 1rem;
}
.storyteller-form .schedule-section .day-item .activities-section .add-button,
.storyteller-form .schedule-section .day-item .meals-section .add-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.15s ease-in-out;
  cursor: pointer;
  border: 1px solid transparent;
}
.storyteller-form .schedule-section .day-item .activities-section .add-button:disabled,
.storyteller-form .schedule-section .day-item .meals-section .add-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.storyteller-form .schedule-section .day-item .activities-section .add-button,
.storyteller-form .schedule-section .day-item .meals-section .add-button {
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  color: #2563eb;
  background: transparent;
}
.storyteller-form .schedule-section .day-item .activities-section .add-button:hover,
.storyteller-form .schedule-section .day-item .meals-section .add-button:hover {
  color: #1d4ed8;
}
.storyteller-form .schedule-section .day-item .activities-section .add-button .icon,
.storyteller-form .schedule-section .day-item .meals-section .add-button .icon {
  height: 1rem;
  width: 1rem;
}
.storyteller-form .schedule-section .add-day-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.15s ease-in-out;
  cursor: pointer;
  border: 1px solid transparent;
}
.storyteller-form .schedule-section .add-day-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.storyteller-form .schedule-section .add-day-button {
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  color: #2563eb;
  background: transparent;
}
.storyteller-form .schedule-section .add-day-button:hover {
  color: #1d4ed8;
}
.storyteller-form .schedule-section .add-day-button .icon {
  height: 1rem;
  width: 1rem;
}
.storyteller-form .form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding-top: 1.5rem;
}
.storyteller-form .form-actions .cancel-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.15s ease-in-out;
  cursor: pointer;
  border: 1px solid transparent;
}
.storyteller-form .form-actions .cancel-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.storyteller-form .form-actions .cancel-button {
  padding: 0.5rem 1.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #6b7280;
  background: white;
  border: 1px solid #e5e7eb;
}
.storyteller-form .form-actions .cancel-button:hover {
  background: #f9fafb;
}
.storyteller-form .form-actions .cancel-button:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);
}
.storyteller-form .form-actions .submit-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.15s ease-in-out;
  cursor: pointer;
  border: 1px solid transparent;
}
.storyteller-form .form-actions .submit-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.storyteller-form .form-actions .submit-button {
  gap: 0.5rem;
  padding: 0.5rem 1.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: white;
  background: #2563eb;
  border: 1px solid transparent;
}
.storyteller-form .form-actions .submit-button:hover {
  background: #1d4ed8;
}
.storyteller-form .form-actions .submit-button:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);
}
.storyteller-form .form-actions .submit-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.storyteller-form .form-actions .submit-button .loading-spinner {
  animation: spin 1s linear infinite;
  border-radius: 50%;
  height: 1rem;
  width: 1rem;
  border: 2px solid transparent;
  border-top-color: white;
}
.storyteller-form .form-actions .submit-button .icon {
  height: 1rem;
  width: 1rem;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.storyteller-form .form-textarea {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-family: inherit;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #111827;
  background: white;
  resize: vertical;
  min-height: 400px;
}
.storyteller-form .form-textarea:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 1px #2563eb;
}
.storyteller-form .form-textarea::placeholder {
  color: #6b7280;
}
.storyteller-form .form-field.error .form-textarea {
  border-color: #ef4444;
}
.storyteller-form .form-field.error .form-textarea:focus {
  border-color: #ef4444;
  box-shadow: 0 0 0 1px #ef4444;
}

@media (max-width: 768px) {
  .storyteller-form .form-container {
    padding: 1rem;
  }
  .storyteller-form .form-header .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
  .storyteller-form .form-section {
    padding: 1rem;
  }
  .storyteller-form .form-actions {
    flex-direction: column;
  }
  .storyteller-form .form-actions .cancel-button,
  .storyteller-form .form-actions .submit-button {
    width: 100%;
  }
  .storyteller-form .form-textarea {
    min-height: 300px;
    font-size: 0.8rem;
    padding: 0.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/StorytellerForm.scss"],"names":[],"mappings":"AAqGA;EACE,iBAAA;EACA,oCAAA;AApGF;AAsGE;EAEE,cAAA;EACA,eAAA;AArGJ;AAwGE;EACE,mBAAA;AAtGJ;AAwGI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAtGN;AAyGQ;EACE,mBAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAjHK;EAkHL,SAAA;AAvGV;AA0GQ;EACE,cArHO;EAsHP,oBAAA;AAxGV;AA4GM;EA1GJ,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAhBc;EAiBd,mBAAA;EACA,gBAAA;EACA,iCAAA;EACA,eAAA;EACA,6BAAA;AACF;AACE;EACE,YAAA;EACA,mBAAA;AACJ;AA6FM;EAEE,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAhIS;AAoCjB;AA8FQ;EACE,cApIK;AAwCf;AA+FQ;EACE,YAAA;EACA,WAAA;AA7FV;AAmGE;EACE,qBAAA;EACA,qBA5Ie;EA6If,aAAA;AAjGJ;AAmGI;EACE,yCAAA;EACA,oCAAA;AAjGN;AAoGQ;EACE,mBAAA;EACA,gBAAA;EACA,sDAAA;EACA,SAAA;AAlGV;AAuGI;EACE,wCAAA;EACA,mCAAA;AArGN;AAwGQ;EACE,mBAAA;EACA,gBAAA;EACA,qDAAA;EACA,SAAA;AAtGV;AA4GE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA1GJ;AA6GE;EArJA,iBAAA;EACA,yBAAA;EACA,qBA/BiB;EAgCjB,2CAnCU;EAuLR,eAAA;AAxGJ;AA0GI;EAjIF,aAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;EACA,eAAA;AA0BF;AAxBE;EACE,gBAAA;AA0BJ;AAxBI;EACE,mBAAA;EACA,gBAAA;EACA,cAvES;EAwET,SAAA;AA0BN;AAvBI;EACE,mBAAA;EACA,cA5EW;EA6EX,qBAAA;AAyBN;AArBE;EACE,eAAA;EACA,cAAA;EACA,cApFa;EAqFb,sCAAA;AAuBJ;AAmFM;EACE,aAAA;EACA,0BAAA;EACA,WAAA;AAjFR;AAmFQ;EALF;IAMI,qCAAA;EAhFR;AACF;AAmFU;EADF;IAEI,qCAAA;EAhFV;AACF;AAmFQ;EACE,0BAAA;AAjFV;AAmFU;EAHF;IAII,mBAAA;EAhFV;AACF;AAoFM;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAlFR;AAoFQ;EACE,mBAAA;EACA,gBAAA;EACA,cAhOK;AA8If;AAoFU;EACE,cAvOE;AAqJd;AAsFQ;;;EA9LN,WAAA;EACA,uBAAA;EACA,yBAAA;EACA,uBAxCc;EAyCd,mBAAA;EACA,cA9Ca;EA+Cb,iBAAA;EACA,wEAAA;AA6GF;AA3GE;;;EACE,cAlDa;AAiKjB;AAzJE;;;EACE,aAAA;EACA,qBAnBY;EAoBZ,6BAAA;AA6JJ;AAoEQ;EACE,gBAAA;EACA,gBAAA;AAlEV;AAsEM;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AApER;AAsEQ;EACE,YAAA;EACA,WAAA;EACA,uBAvPM;EAwPN,yBAAA;EACA,cArQM;AAiMhB;AAsEU;EACE,aAAA;EACA,4CAAA;AApEZ;AAwEQ;EACE,mBAAA;EACA,gBAAA;EACA,cAxQK;EAyQL,SAAA;AAtEV;AA6EI;EACE,yBAAA;EACA,uBA9QU;EA+QV,aAAA;EACA,mBAAA;AA3EN;AA6EM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;AA3ER;AA6EQ;EACE,mBAAA;EACA,gBAAA;EACA,cA/RK;EAgSL,SAAA;AA3EV;AA8EQ;EACE,cAxSI;AA4Nd;AA8EU;EACE,wDAAA;AA5EZ;AA+EU;EACE,YAAA;EACA,WAAA;AA7EZ;AAkFM;EACE,aAAA;EACA,0BAAA;EACA,SAAA;AAhFR;AAkFQ;EALF;IAMI,qCAAA;EA/ER;AACF;AAmFI;EA3SF,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAhBc;EAiBd,mBAAA;EACA,gBAAA;EACA,iCAAA;EACA,eAAA;EACA,6BAAA;AA2NF;AAzNE;EACE,YAAA;EACA,mBAAA;AA2NJ;AAoEI;EAEE,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAzUU;EA0UV,uBAAA;AAnEN;AAqEM;EACE,cA5UQ;AAyQhB;AAsEM;EACE,YAAA;EACA,WAAA;AApER;AA0EI;EACE,aAAA;EACA,WAAA;EACA,qBAAA;AAxEN;AA0EM;EACE,SAAA;EA7SN,WAAA;EACA,uBAAA;EACA,yBAAA;EACA,uBAxCc;EAyCd,mBAAA;EACA,cA9Ca;EA+Cb,iBAAA;EACA,wEAAA;AAsOF;AApOE;EACE,cAlDa;AAwRjB;AAhRE;EACE,aAAA;EACA,qBAnBY;EAoBZ,6BAAA;AAkRJ;AA4DM;EACE,uBAAA;EACA,cAhWM;AAsSd;AA4DQ;EACE,wDAAA;AA1DV;AA6DQ;EACE,YAAA;EACA,WAAA;AA3DV;AAgEI;EAxVF,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAhBc;EAiBd,mBAAA;EACA,gBAAA;EACA,iCAAA;EACA,eAAA;EACA,6BAAA;AA2RF;AAzRE;EACE,YAAA;EACA,mBAAA;AA2RJ;AAiDI;EAEE,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAtXU;EAuXV,uBAAA;AAhDN;AAkDM;EACE,cAzXQ;AAyUhB;AAmDM;EACE,YAAA;EACA,WAAA;AAjDR;AAuDI;EACE,yBAAA;EACA,uBA3XU;EA4XV,aAAA;EACA,qBAAA;AArDN;AAuDM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AArDR;AAuDQ;EACE,mBAAA;EACA,gBAAA;EACA,cA5YK;EA6YL,SAAA;AArDV;AAwDQ;EACE,cArZI;AA+Vd;AAwDU;EACE,wDAAA;AAtDZ;AAyDU;EACE,YAAA;EACA,WAAA;AAvDZ;AA4DM;EACE,aAAA;EACA,0BAAA;EACA,SAAA;EACA,mBAAA;AA1DR;AA4DQ;EANF;IAOI,qCAAA;EAzDR;AACF;AA2DQ;EACE,iBAAA;AAzDV;AA6DM;;EAEE,mBAAA;AA3DR;AA6DQ;;EACE,mBAAA;EACA,gBAAA;EACA,cApbK;EAqbL,qBAAA;EACA,cAAA;AA1DV;AA6DQ;;;;EAEE,aAAA;EACA,WAAA;EACA,qBAAA;AAzDV;AA2DU;;;;EAtZR,WAAA;EACA,uBAAA;EACA,yBAAA;EACA,uBAxCc;EAyCd,mBAAA;EACA,cA9Ca;EA+Cb,iBAAA;EACA,wEAAA;AAiWF;AA/VE;;;;EACE,cAlDa;AAsZjB;AA9YE;;;;EACE,aAAA;EACA,qBAnBY;EAoBZ,6BAAA;AAmZJ;AAmCY;;;;EACE,WAAA;AA9Bd;AAiCY;;;;EACE,SAAA;AA5Bd;AAgCU;;;;EACE,uBAAA;EACA,cAjdE;AAsbd;AA6BY;;;;EACE,wDAAA;AAxBd;AA2BY;;;;EACE,YAAA;EACA,WAAA;AAtBd;AA2BQ;;EAzcN,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAhBc;EAiBd,mBAAA;EACA,gBAAA;EACA,iCAAA;EACA,eAAA;EACA,6BAAA;AAkbF;AAhbE;;EACE,YAAA;EACA,mBAAA;AAmbJ;AAUQ;;EAEE,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAveM;EAweN,uBAAA;AARV;AAUU;;EACE,cA1eI;AAmehB;AAUU;;EACE,YAAA;EACA,WAAA;AAPZ;AAaI;EA7dF,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAhBc;EAiBd,mBAAA;EACA,gBAAA;EACA,iCAAA;EACA,eAAA;EACA,6BAAA;AAmdF;AAjdE;EACE,YAAA;EACA,mBAAA;AAmdJ;AAFI;EAEE,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,cA3fU;EA4fV,uBAAA;AAGN;AADM;EACE,cA9fQ;AAigBhB;AAAM;EACE,YAAA;EACA,WAAA;AAER;AAGE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,mBAAA;AADJ;AAGI;EAtfF,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAhBc;EAiBd,mBAAA;EACA,gBAAA;EACA,iCAAA;EACA,eAAA;EACA,6BAAA;AAsfF;AApfE;EACE,YAAA;EACA,mBAAA;AAsfJ;AAZI;EAEE,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cA3gBW;EA4gBX,iBAAA;EACA,yBAAA;AAaN;AAXM;EACE,mBAnhBW;AAgiBnB;AAVM;EACE,aAAA;EACA,4CAAA;AAYR;AARI;EAzgBF,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAhBc;EAiBd,mBAAA;EACA,gBAAA;EACA,iCAAA;EACA,eAAA;EACA,6BAAA;AAohBF;AAlhBE;EACE,YAAA;EACA,mBAAA;AAohBJ;AAvBI;EAEE,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAziBU;EA0iBV,6BAAA;AAwBN;AAtBM;EACE,mBA5iBQ;AAokBhB;AArBM;EACE,aAAA;EACA,4CAAA;AAuBR;AApBM;EACE,YAAA;EACA,mBAAA;AAsBR;AAnBM;EACE,kCAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,6BAAA;EACA,uBAAA;AAqBR;AAlBM;EACE,YAAA;EACA,WAAA;AAoBR;;AAdA;EACE;IACE,yBAAA;EAiBF;AACF;AAZE;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAnlBW;EAolBX,iBAAA;EACA,gBAAA;EACA,iBAAA;AAcJ;AAZI;EACE,aAAA;EACA,qBAlmBU;EAmmBV,6BAAA;AAcN;AAXI;EACE,cA9lBW;AA2mBjB;AAPI;EACE,qBA1mBQ;AAmnBd;AAPM;EACE,qBA7mBM;EA8mBN,6BAAA;AASR;;AAFA;EAEI;IACE,aAAA;EAIJ;EAAI;IACE,sBAAA;IACA,uBAAA;IACA,SAAA;EAEN;EAEE;IACE,aAAA;EAAJ;EAGE;IACE,sBAAA;EADJ;EAGI;;IAEE,WAAA;EADN;EAME;IACE,iBAAA;IACA,iBAAA;IACA,eAAA;EAJJ;AACF","sourcesContent":["// StorytellerForm SCSS Styles\n@use \"sass:color\";\n\n$primary-color: #2563eb;\n$primary-hover: #1d4ed8;\n$secondary-color: #6b7280;\n$success-color: #10b981;\n$error-color: #ef4444;\n$warning-color: #f59e0b;\n$background-light: #f9fafb;\n$border-color: #e5e7eb;\n$text-primary: #111827;\n$text-secondary: #6b7280;\n$shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n$shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n$border-radius: 0.375rem;\n$border-radius-lg: 0.5rem;\n\n// Mixins\n@mixin focus-ring {\n  &:focus {\n    outline: none;\n    border-color: $primary-color;\n    box-shadow: 0 0 0 1px $primary-color;\n  }\n}\n\n@mixin button-base {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: $border-radius;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: all 0.15s ease-in-out;\n  cursor: pointer;\n  border: 1px solid transparent;\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n}\n\n@mixin card-style {\n  background: white;\n  border: 1px solid $border-color;\n  border-radius: $border-radius-lg;\n  box-shadow: $shadow-sm;\n}\n\n@mixin input-style {\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  border: 1px solid $border-color;\n  border-radius: $border-radius;\n  font-size: 0.875rem;\n  color: $text-primary;\n  background: white;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n\n  &::placeholder {\n    color: $text-secondary;\n  }\n\n  @include focus-ring;\n}\n\n@mixin section-header {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1.5rem;\n  cursor: pointer;\n\n  .section-title {\n    text-align: left;\n\n    h2 {\n      font-size: 1.125rem;\n      font-weight: 600;\n      color: $text-primary;\n      margin: 0;\n    }\n\n    p {\n      font-size: 0.875rem;\n      color: $text-secondary;\n      margin: 0.25rem 0 0 0;\n    }\n  }\n\n  .chevron-icon {\n    height: 1.25rem;\n    width: 1.25rem;\n    color: $text-secondary;\n    transition: transform 0.2s ease-in-out;\n  }\n}\n\n.storyteller-form {\n  min-height: 100vh;\n  background: rgba($background-light, 0.5);\n\n  .form-container {\n    // max-width: 6rem;\n    margin: 0 auto;\n    padding: 1.5rem;\n  }\n\n  .form-header {\n    margin-bottom: 2rem;\n\n    .header-content {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n\n      .header-text {\n        h1 {\n          font-size: 1.875rem;\n          font-weight: 700;\n          letter-spacing: -0.025em;\n          color: $text-primary;\n          margin: 0;\n        }\n\n        p {\n          color: $text-secondary;\n          margin: 0.5rem 0 0 0;\n        }\n      }\n\n      .cancel-button {\n        @include button-base;\n        gap: 0.5rem;\n        padding: 0.5rem 1rem;\n        font-size: 0.875rem;\n        font-weight: 500;\n        color: $text-secondary;\n\n        &:hover {\n          color: $text-primary;\n        }\n\n        .icon {\n          height: 1rem;\n          width: 1rem;\n        }\n      }\n    }\n  }\n\n  .alert {\n    margin-bottom: 1.5rem;\n    border-radius: $border-radius-lg;\n    padding: 1rem;\n\n    &.success {\n      border: 1px solid rgba($success-color, 0.2);\n      background: rgba($success-color, 0.05);\n\n      .alert-content {\n        p {\n          font-size: 0.875rem;\n          font-weight: 500;\n          color: color.adjust($success-color, $lightness: -20%);\n          margin: 0;\n        }\n      }\n    }\n\n    &.error {\n      border: 1px solid rgba($error-color, 0.2);\n      background: rgba($error-color, 0.05);\n\n      .alert-content {\n        p {\n          font-size: 0.875rem;\n          font-weight: 500;\n          color: color.adjust($error-color, $lightness: -20%);\n          margin: 0;\n        }\n      }\n    }\n  }\n\n  .form-sections {\n    display: flex;\n    flex-direction: column;\n    gap: 2rem;\n  }\n\n  .form-section {\n    @include card-style;\n    padding: 1.5rem;\n\n    .section-header {\n      @include section-header;\n    }\n\n    .section-content {\n      .form-grid {\n        display: grid;\n        grid-template-columns: 1fr;\n        gap: 1.5rem;\n\n        @media (min-width: 768px) {\n          grid-template-columns: repeat(2, 1fr);\n        }\n\n        &.three-cols {\n          @media (min-width: 1024px) {\n            grid-template-columns: repeat(3, 1fr);\n          }\n        }\n\n        &.full-width {\n          grid-template-columns: 1fr;\n\n          @media (min-width: 768px) {\n            grid-column: span 2;\n          }\n        }\n      }\n\n      .form-field {\n        display: flex;\n        flex-direction: column;\n        gap: 0.5rem;\n\n        label {\n          font-size: 0.875rem;\n          font-weight: 500;\n          color: $text-primary;\n\n          .required {\n            color: $error-color;\n          }\n        }\n\n        input,\n        textarea,\n        select {\n          @include input-style;\n        }\n\n        textarea {\n          resize: vertical;\n          min-height: 4rem;\n        }\n      }\n\n      .checkbox-field {\n        display: flex;\n        align-items: center;\n        gap: 0.75rem;\n\n        input[type=\"checkbox\"] {\n          height: 1rem;\n          width: 1rem;\n          border-radius: $border-radius;\n          border: 1px solid $border-color;\n          color: $primary-color;\n\n          &:focus {\n            outline: none;\n            box-shadow: 0 0 0 2px rgba($primary-color, 0.2);\n          }\n        }\n\n        label {\n          font-size: 0.875rem;\n          font-weight: 500;\n          color: $text-primary;\n          margin: 0;\n        }\n      }\n    }\n  }\n\n  .array-section {\n    .array-item {\n      border: 1px solid $border-color;\n      border-radius: $border-radius;\n      padding: 1rem;\n      margin-bottom: 1rem;\n\n      .item-header {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        margin-bottom: 0.75rem;\n\n        h4 {\n          font-size: 0.875rem;\n          font-weight: 500;\n          color: $text-primary;\n          margin: 0;\n        }\n\n        .delete-button {\n          color: $error-color;\n\n          &:hover {\n            color: color.adjust($error-color, $lightness: -10%);\n          }\n\n          .icon {\n            height: 1rem;\n            width: 1rem;\n          }\n        }\n      }\n\n      .item-content {\n        display: grid;\n        grid-template-columns: 1fr;\n        gap: 1rem;\n\n        @media (min-width: 768px) {\n          grid-template-columns: repeat(2, 1fr);\n        }\n      }\n    }\n\n    .add-button {\n      @include button-base;\n      gap: 0.5rem;\n      padding: 0.5rem 0.75rem;\n      font-size: 0.875rem;\n      color: $primary-color;\n      background: transparent;\n\n      &:hover {\n        color: $primary-hover;\n      }\n\n      .icon {\n        height: 1rem;\n        width: 1rem;\n      }\n    }\n  }\n\n  .array-field {\n    .array-item {\n      display: flex;\n      gap: 0.5rem;\n      margin-bottom: 0.5rem;\n\n      input {\n        flex: 1;\n        @include input-style;\n      }\n\n      .delete-button {\n        padding: 0.5rem 0.75rem;\n        color: $error-color;\n\n        &:hover {\n          color: darken($error-color, 10%);\n        }\n\n        .icon {\n          height: 1rem;\n          width: 1rem;\n        }\n      }\n    }\n\n    .add-button {\n      @include button-base;\n      gap: 0.5rem;\n      padding: 0.5rem 0.75rem;\n      font-size: 0.875rem;\n      color: $primary-color;\n      background: transparent;\n\n      &:hover {\n        color: $primary-hover;\n      }\n\n      .icon {\n        height: 1rem;\n        width: 1rem;\n      }\n    }\n  }\n\n  .schedule-section {\n    .day-item {\n      border: 1px solid $border-color;\n      border-radius: $border-radius;\n      padding: 1rem;\n      margin-bottom: 1.5rem;\n\n      .day-header {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        margin-bottom: 1rem;\n\n        h4 {\n          font-size: 0.875rem;\n          font-weight: 500;\n          color: $text-primary;\n          margin: 0;\n        }\n\n        .delete-button {\n          color: $error-color;\n\n          &:hover {\n            color: color.adjust($error-color, $lightness: -10%);\n          }\n\n          .icon {\n            height: 1rem;\n            width: 1rem;\n          }\n        }\n      }\n\n      .day-content {\n        display: grid;\n        grid-template-columns: 1fr;\n        gap: 1rem;\n        margin-bottom: 1rem;\n\n        @media (min-width: 768px) {\n          grid-template-columns: repeat(2, 1fr);\n        }\n\n        .full-width {\n          grid-column: 1 / -1;\n        }\n      }\n\n      .activities-section,\n      .meals-section {\n        margin-bottom: 1rem;\n\n        label {\n          font-size: 0.875rem;\n          font-weight: 500;\n          color: $text-primary;\n          margin-bottom: 0.5rem;\n          display: block;\n        }\n\n        .activity-item,\n        .meal-item {\n          display: flex;\n          gap: 0.5rem;\n          margin-bottom: 0.5rem;\n\n          input {\n            @include input-style;\n\n            &.time-input {\n              width: 8rem;\n            }\n\n            &.flex-input {\n              flex: 1;\n            }\n          }\n\n          .delete-button {\n            padding: 0.5rem 0.75rem;\n            color: $error-color;\n\n            &:hover {\n              color: color.adjust($error-color, $lightness: -10%);\n            }\n\n            .icon {\n              height: 1rem;\n              width: 1rem;\n            }\n          }\n        }\n\n        .add-button {\n          @include button-base;\n          gap: 0.5rem;\n          padding: 0.5rem 0.75rem;\n          font-size: 0.875rem;\n          color: $primary-color;\n          background: transparent;\n\n          &:hover {\n            color: $primary-hover;\n          }\n\n          .icon {\n            height: 1rem;\n            width: 1rem;\n          }\n        }\n      }\n    }\n\n    .add-day-button {\n      @include button-base;\n      gap: 0.5rem;\n      padding: 0.5rem 1rem;\n      font-size: 0.875rem;\n      color: $primary-color;\n      background: transparent;\n\n      &:hover {\n        color: $primary-hover;\n      }\n\n      .icon {\n        height: 1rem;\n        width: 1rem;\n      }\n    }\n  }\n\n  .form-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 1rem;\n    padding-top: 1.5rem;\n\n    .cancel-button {\n      @include button-base;\n      padding: 0.5rem 1.5rem;\n      font-size: 0.875rem;\n      font-weight: 500;\n      color: $text-secondary;\n      background: white;\n      border: 1px solid $border-color;\n\n      &:hover {\n        background: $background-light;\n      }\n\n      &:focus {\n        outline: none;\n        box-shadow: 0 0 0 2px rgba($primary-color, 0.2);\n      }\n    }\n\n    .submit-button {\n      @include button-base;\n      gap: 0.5rem;\n      padding: 0.5rem 1.5rem;\n      font-size: 0.875rem;\n      font-weight: 500;\n      color: white;\n      background: $primary-color;\n      border: 1px solid transparent;\n\n      &:hover {\n        background: $primary-hover;\n      }\n\n      &:focus {\n        outline: none;\n        box-shadow: 0 0 0 2px rgba($primary-color, 0.2);\n      }\n\n      &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n      }\n\n      .loading-spinner {\n        animation: spin 1s linear infinite;\n        border-radius: 50%;\n        height: 1rem;\n        width: 1rem;\n        border: 2px solid transparent;\n        border-top-color: white;\n      }\n\n      .icon {\n        height: 1rem;\n        width: 1rem;\n      }\n    }\n  }\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n// Textarea styling\n.storyteller-form {\n  .form-textarea {\n    width: 100%;\n    padding: 0.75rem;\n    border: 1px solid $border-color;\n    border-radius: 6px;\n    font-family: inherit;\n    font-size: 0.875rem;\n    line-height: 1.5;\n    color: $text-primary;\n    background: white;\n    resize: vertical;\n    min-height: 400px;\n\n    &:focus {\n      outline: none;\n      border-color: $primary-color;\n      box-shadow: 0 0 0 1px $primary-color;\n    }\n\n    &::placeholder {\n      color: $text-secondary;\n    }\n  }\n\n  // Error state for textarea\n  .form-field.error {\n    .form-textarea {\n      border-color: $error-color;\n\n      &:focus {\n        border-color: $error-color;\n        box-shadow: 0 0 0 1px $error-color;\n      }\n    }\n  }\n}\n\n// Responsive adjustments\n@media (max-width: 768px) {\n  .storyteller-form {\n    .form-container {\n      padding: 1rem;\n    }\n\n    .form-header {\n      .header-content {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 1rem;\n      }\n    }\n\n    .form-section {\n      padding: 1rem;\n    }\n\n    .form-actions {\n      flex-direction: column;\n\n      .cancel-button,\n      .submit-button {\n        width: 100%;\n      }\n    }\n\n    // Mobile textarea adjustments\n    .form-textarea {\n      min-height: 300px;\n      font-size: 0.8rem;\n      padding: 0.5rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
